export default {
      id: "open-in-full-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#open-in-full-usage",
      toString: function () {
        return this.url;
      }
    }